import {
  and,
  getDocs,
  orderBy,
  query,
  QueryFieldFilterConstraint,
  where,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { lifeAreaConverter } from './converters/life-area';
import { CollectionOptions, getAuthentication, getCollection } from './helpers';

export type Options = {
  ids?: ID[];
};

export const getLifeAreas = async (options: Options = {}) => {
  const auth = await getAuthentication();

  const conditions = [
    where('roles.all', 'array-contains', auth.currentUser?.uid),

    !!options.ids?.length && where('id', 'in', options.ids),
  ].filter(Boolean) as QueryFieldFilterConstraint[];

  return query(
    getCollection(CollectionOptions.LifeAreas).withConverter(lifeAreaConverter),
    and(...conditions),
    orderBy('createdAt', 'asc'),
  );
};

export const getLifeAreasDocs = async (options?: Options) => {
  const lifeAreaQuery = await getLifeAreas(options);
  const lifeAreaDocs = await getDocs(lifeAreaQuery);

  return lifeAreaDocs.docs.map((doc) => doc.data());
};
